import { createFeatureSelector, createSelector } from '@ngrx/store'
import { TAXES_FEATURE_KEY, TaxesState, taxesAdapter } from './taxes.reducer'

export const selectTaxesState = createFeatureSelector<TaxesState>(TAXES_FEATURE_KEY)

const { selectAll, selectEntities } = taxesAdapter.getSelectors()

export const selectTaxesLoaded = createSelector(selectTaxesState, (state: TaxesState) => state.loaded)

export const selectAllTaxes = createSelector(selectTaxesState, (state: TaxesState) => selectAll(state))

export const selectTaxesEntities = createSelector(selectTaxesState, (state: TaxesState) => selectEntities(state))

export const selectSelectedId = createSelector(selectTaxesState, (state: TaxesState) => state.selectedId)

export const selectEntity = createSelector(selectTaxesEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)
export const selectTaxByUuid = (uuid: string) => createSelector(selectTaxesEntities, (entities) => entities[uuid])

export const selectEditCreateLoaded = createSelector(selectTaxesState, (state) => state.editCreateLoaded)
